import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import roLang from '../dictionaries/ro.json';
import ruLang from '../dictionaries/ru.json';

const resources = {
    ro: {
        translation: roLang,
    },
    ru: {
        translation: ruLang,
    },
};

const storedLanguage = localStorage.getItem('i18nextLng'); // Retrieve stored language

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: storedLanguage || 'ro', // Initialize with stored language or default to 'ro'
        interpolation: {
            escapeValue: false,
        },
    });

// Listen for language change events and store the new language in browser storage
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('i18nextLng', lng);
});

export default i18n;
